import { ProductCarouselFinalItemProp } from '@allesauto/core/productCarouselFinalItem';
import { ProductTeaserMinimalProps } from '@allesauto/core/productTeaserMinimal';
import { HeadlineVariation } from '@allesauto/utils/consts';
import { sbEditable } from '@storyblok/storyblok-editable';
import React, { FC } from 'react';

import ProductsCarousel from '../ProductsCarousel/ProductsCarousel';

type CarouselHybridComponentProps = {
  headline: string;
  latestVehicles?: ProductTeaserMinimalProps[];
  component: string;
  _uid: string;
  _editable?: string;
  itemsAmount?: number;
  buttonLabel?: string;
  closingTile?: ProductCarouselFinalItemProp[];
  totalCount: number;
  buttonLink?: string;
};

const CarouselHybridComponent: FC<
  React.PropsWithChildren<CarouselHybridComponentProps>
> = (props) => {
  const {
    headline,
    latestVehicles,
    closingTile,
    itemsAmount,
    buttonLabel,
    totalCount,
    buttonLink,
  } = props;

  const filteredLatestVehicles = latestVehicles
    ? latestVehicles.slice(0, itemsAmount)
    : [];

  return (
    <div {...sbEditable(props)}>
      <ProductsCarousel
        products={filteredLatestVehicles}
        headlineKeyTranslation={headline}
        isHeadlineKeyTranslation={false}
        headlineType={HeadlineVariation.H2}
        closingTile={closingTile}
        buttonLabel={buttonLabel}
        totalCount={totalCount}
        buttonLink={buttonLink}
      />
    </div>
  );
};

export default CarouselHybridComponent;
